import { format as formatDate, parseISO } from 'date-fns'
import {
  Config,
  pluckLuggageRequirements,
  pluckOversizedLuggageRequirements,
  pluckPassengerRequirements,
} from '../../common'
import PassengersTag from '../PassengersTag'
import LuggageTag from '../LuggageTag'
import ChildSeatsTag from '../ChildSeatsTag'
import React, { FC } from 'react'
import { TransferDirection, Transfer } from '../../types'

import { formatAirport } from '../../transforms/airport'
import ArrowIcon from '../../images/arrow-icon.svg'
import SummaryRow from '../SummaryRow'
import OversizedLuggageTag from '../OversizedLuggageTag'

interface Props {
  transfer: Transfer
  isActive?: boolean
  icon?: boolean
  showContactInformation?: boolean
  showTags?: boolean
  onRemove?: (transfer: Transfer) => void
  onSelect?: (transfer: Transfer) => void
}

const TransferSummaryListItem: FC<Props> = ({
  transfer,
  icon = false,
  showTags = true,
  showContactInformation = false,
  isActive = false,
  onSelect,
  onRemove,
  children,
}) => {
  const { direction, pickup_datetime, flight_number } = transfer
  const address = transfer.address_formatted
  const airport = formatAirport(transfer)
  const [origin, destination] = direction === TransferDirection.ToAirport ? [address, airport] : [airport, address]
  const formattedDate = formatDate(parseISO(pickup_datetime), Config.DateFormat)
  const formattedTime = formatDate(parseISO(pickup_datetime), Config.TimeFormat)

  return (
    <div
      key={transfer.booking_id}
      className={`summary__list-item px-2 pt-2 px-lg-4 pt-lg-4 pb-3 ${isActive ? 'active' : ''}`}
      onClick={() => onSelect?.(transfer)}
    >
      <div className="d-flex">
        <div className="flex-grow-1">
          <SummaryRow label="From" text={origin} className="pt-2" />
          <SummaryRow label="To" text={destination} />
          <SummaryRow label="Pick up" text={`${formattedDate} at ${formattedTime}`} />
          <SummaryRow label="Flight" text={flight_number} />

          {showContactInformation && (
            <>
              <SummaryRow label="Contact" text={`${transfer.contact_first_name} ${transfer.contact_last_name}`} />
              <SummaryRow label="Phone" text={transfer.contact_phone} />
            </>
          )}

          {showTags && (
            <div className="d-flex align-items-center pb-2 pl-2 mt-2">
              <div className="summary-row-left pr-2 d-flex flex-grow-1">
                <PassengersTag requirements={pluckPassengerRequirements(transfer)} />
                <LuggageTag requirements={pluckLuggageRequirements(transfer)} />
                <OversizedLuggageTag requirements={pluckOversizedLuggageRequirements(transfer)} />
              </div>
            </div>
          )}

          {children}
        </div>

        {icon && !isActive && (
          <div className="summary__list-item__icon pl-2">
            <button className="btn btn-link d-flex h-100 align-items-center text-secondary align-items-center text-decoration-none px-2 px-lg-3">
              <img src={ArrowIcon} alt="Booking" />
            </button>
          </div>
        )}

        {onRemove && (
          <div className="d-flex pb-2 pl-2 mt-2 align-items-end justify-content-end">
            <a
              href="#"
              onClick={(event) => {
                event.preventDefault()
                onRemove(transfer)
              }}
              className="text-secondary cursor-pointer placeholder-text small-text"
            >
              <u>Remove</u>
            </a>
          </div>
        )}
      </div>
    </div>
  )
}

export default TransferSummaryListItem
